module.exports = __webpack_public_path__ + "img/step_five.78e517a0.png";